import { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCatalog } from '../catalogContext';
import { useSearch } from '../searchContext';
import { pieceName } from '../shopItems';
import { searchCatalog } from '../search';

const SearchDrawer = () => {
    const { shopItems } = useCatalog();
    const { open, setOpen, query, setQuery } = useSearch();
    const navigate = useNavigate();
    const inputRef = useRef(null);
    const results = searchCatalog(shopItems, query, 8);

    useEffect(() => {
        if (open) {
            window.requestAnimationFrame(() => inputRef.current?.focus());
        } else {
            setQuery('');
        }
    }, [open, setQuery]);

    const close = () => setOpen(false);

    const goShop = (event) => {
        event.preventDefault();
        const q = query.trim();
        close();
        navigate(q ? `/shop?q=${encodeURIComponent(q)}` : '/shop');
    };

    if (!open) {
        return null;
    }

    return (
        <>
            <div className="searchOverlay" onClick={close} />
            <div className="searchDrawer" role="dialog" aria-label="Search">
                <form className="searchForm" onSubmit={goShop}>
                    <label className="searchLabel" htmlFor="site-search">Search</label>
                    <input
                        id="site-search"
                        ref={inputRef}
                        className="searchInput"
                        type="search"
                        value={query}
                        onChange={(event) => setQuery(event.target.value)}
                        placeholder="Prints, stickers, titles…"
                        autoComplete="off"
                    />
                    <button className="searchClose" type="button" onClick={close} aria-label="Close search">
                        &times;
                    </button>
                </form>
                {query.trim() ?
                    <div className="searchResults">
                        {results.length ?
                            results.map((item) => {
                                const { name } = pieceName(item, { shop: true });
                                return (
                                    <Link
                                        key={item.id}
                                        className="searchResult"
                                        to={`/products/${item.id}`}
                                        onClick={close}
                                    >
                                        <img src={item.image} alt="" />
                                        <span>
                                            <strong>{name}</strong>
                                            <em>{item.category}{item.format === 'sticker' ? ' · Sticker' : ''}</em>
                                        </span>
                                        <b>${Number(item.price).toFixed(0)}</b>
                                    </Link>
                                );
                            })
                            :
                            <p className="searchEmpty">No pieces match “{query.trim()}”.</p>
                        }
                        <button className="searchAll" type="button" onClick={goShop}>
                            Search the shop
                        </button>
                    </div>
                    :
                    <p className="searchHint">Try lotus, kiku, sticker, or a collection name.</p>
                }
            </div>
        </>
    );
};

export default SearchDrawer;
